import { useFilterSearchParams } from "@/utils/hooksUtils";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../../agent/api";
import { DEFAULT_POINTS_QUERY_PARAMS } from "../api";
import { PointsReportFilterForm } from "../components/PointsReportFilterForm";
import { PointsReportTable } from "../components/PointsReportTable";
import { PointsReportFilterPageRequest } from "../types";

export const PointsReportContainer = () => {
  const searchParams = useFilterSearchParams<PointsReportFilterPageRequest>({
    params: [
      "orderBy",
      "orderDirections",
      "orderByPeriodIndex",
      "periodStartDate",
      "periodEndDate",
      "keyword",
      "institutionIds",
      "productIds",
      "commissionBatchIds",
      ...COMMON_AGENT_FILTER_SEARCH_PARAMS,
      "reportType",
      "commissionBatchType",
    ],
    defaultQueryParamsObject: DEFAULT_POINTS_QUERY_PARAMS,
  });

  return (
    <>
      <PointsReportFilterForm searchParams={searchParams} />

      <PointsReportTable searchParams={searchParams} />
    </>
  );
};
